module.exports = __webpack_public_path__ + "e3b654decb1d5d3eaaeb44adf46f0272.png";